var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state !== "Closed"
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm.Initialized === false
                  ? _c("h2", [
                      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                      _vm._v(" Loading...\n                    "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.Initialized
                  ? _c("div", [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.Name,
                              expression: "Name",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.Name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.Name = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.nameError)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Description")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.Description,
                              expression: "Description",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.Description },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.Description = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Response due date:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.responseDueDate,
                              expression: "responseDueDate",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "date" },
                          domProps: { value: _vm.responseDueDate },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.responseDueDate = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer justify-content-between" },
                [
                  _c("div", { staticClass: "dropdown dropup" }, [
                    _vm.state === "Editor"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu",
                        staticStyle: { padding: "10px" },
                        attrs: { role: "menu" },
                      },
                      [
                        _c("a", { staticClass: "dropdown-item" }, [
                          _vm._v("Cancel"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.DeleteCommand },
                          },
                          [_vm._v("Confirm")]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.state === "Creator"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.CreateCommand },
                          },
                          [_vm._v("Create")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state === "Editor"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.UpdateCommand },
                          },
                          [_vm._v("Save")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }